<template>
  <svg :viewBox="`0 0 ${W} ${H}`" :style="{height: H + 'px', direction: 'ltr'}">
    <defs>
      <linearGradient :id="gid" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stop-color="var(--sd-green-500)" stop-opacity=".3" />
        <stop offset="100%" stop-color="var(--sd-green-500)" stop-opacity=".02" />
      </linearGradient>
    </defs>
    <g v-for="k in 5" :key="k">
      <line :x1="mS" :y1="gy(k - 1)" :x2="W - 10" :y2="gy(k - 1)" stroke="var(--sd-line-2)" stroke-width="1" />
      <text :x="mS - 6" :y="gy(k - 1) + 3.5" class="ax" text-anchor="end">{{ compact(max * (1 - (k - 1) / 4)) }}</text>
    </g>
    <path :d="area" :fill="`url(#${gid})`" />
    <path :d="line" fill="none" stroke="var(--sd-green-500)" stroke-width="2.3" stroke-linejoin="round" stroke-linecap="round" />
    <text v-for="yl in yearLabels" :key="yl.y" :x="yl.x" :y="H - 10" text-anchor="middle" class="ax">{{ yl.y }}</text>
    <rect v-for="(d, i) in data" :key="'h' + i" v-tip="`<b>${d.label}</b><br>${fmt(d.value)} ${unit}`" :x="X(i) - colW / 2" y="0" :width="colW" :height="H"
      fill="transparent" @mousemove="hover = i" @mouseleave="hover = -1" />
    <circle v-if="hover >= 0" :cx="X(hover)" :cy="Y(data[hover].value)" r="5" fill="var(--sd-green-500)" stroke="var(--sd-card)" stroke-width="2.5" />
  </svg>
</template>
<script>
/* Monthly participation area chart. data: [{ label: 'YYYY-MM', value }] */
import { compact, fmt } from '../../lib/format.js'
let uid = 0
export default {
  name: 'SdMonthlyArea',
  props: { data: { type: Array, default: () => [] }, unit: { type: String, default: '' } },
  data: () => ({ W: 980, H: 250, mT: 16, mB: 34, mS: 44, hover: -1, gid: 'sd-tg' + (++uid) }),
  computed: {
    max() { return Math.max(1, ...this.data.map((d) => d.value)) },
    n() { return this.data.length },
    colW() { return (this.W - this.mS) / Math.max(1, this.n) },
    line() { return this.data.map((d, i) => (i ? 'L' : 'M') + this.X(i) + ',' + this.Y(d.value)).join(' ') },
    area() { if (!this.n) return ''; const yB = this.H - this.mB; return `M${this.X(0)},${yB} ` + this.data.map((d, i) => 'L' + this.X(i) + ',' + this.Y(d.value)).join(' ') + ` L${this.X(this.n - 1)},${yB} Z` },
    yearLabels() { const out = []; let last = ''; this.data.forEach((d, i) => { const y = String(d.label).slice(0, 4); if (y !== last) { last = y; out.push({ y, x: this.X(i) }) } }); return out },
  },
  methods: {
    compact, fmt,
    X(i) { return this.mS + (i / Math.max(1, this.n - 1)) * (this.W - this.mS - 10) },
    Y(v) { return this.mT + (1 - v / this.max) * (this.H - this.mT - this.mB) },
    gy(k) { return this.mT + k / 4 * (this.H - this.mT - this.mB) },
  },
}
</script>
